import React, { useState, useRef } from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import YoungImg from "./assets/images/Young_Back.jpg";
import TestimonialSlider from "./components/TestimonialSlider";
import FounderImg from "./assets/images/CZARPROFILE.jpeg";
import html2pdf from "html2pdf.js";
import countries from "./constant/countries";
import CountryDropdown from "./CountryDropdown";

const Home = () => {
  const [formData, setFormData] = useState({ name: "", email: "" });

  const paperRef = useRef();

  const handleDownload = () => {
    const element = paperRef.current;

    // Temporarily show it for PDF rendering
    element.style.display = "block";

    html2pdf()
      .set({
        margin: 0,
        filename: "Tariff_Stock_Exchange_Whitepaper.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
      })
      .from(element)
      .save()
      .then(() => {
        // Hide again after rendering
        element.style.display = "none";
      });
  };
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (formData.name && formData.email) {
      toast.success("🎉 Thank you! You’ve joined the ecosystem.", {
        position: "top-center",
        autoClose: 3000,
      });
      setFormData({ name: "", email: "" });
    } else {
      toast.error("❗ Please fill out both fields.", {
        position: "top-center",
        autoClose: 3000,
      });
    }
  };

  return (
    <>
      <section className="relative bg-[url('./assets/images/Hero_Back.jpg')] bg-cover bg-center bg-no-repeat min-h-screen flex items-center justify-center text-main-light">
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-gray-900/50 to-gray-900/20 z-0"></div>

        {/* Content Container */}
        <div className="relative z-10 w-full max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center lg:text-left flex flex-col justify-center items-center lg:items-start">
          <h1 className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold uppercase font-barlow leading-tight sm:leading-snug animate-slide-in">
            Tariff Stock Exchange
          </h1>

          <p className="mt-4 text-lg sm:text-xl md:text-2xl lg:text-4xl font-aeonik leading-relaxed animate-fade-in max-w-4xl">
            The world’s first fully integrated Tariff Fintech Ecosystem
          </p>

          <p className="mt-3 text-base sm:text-lg md:text-xl lg:text-3xl font-aeonik leading-relaxed animate-fade-in max-w-3xl">
            No need to react. Tariffs can make profits too.
          </p>

          <p className="mt-2 text-sm sm:text-base md:text-lg lg:text-2xl font-aeonik leading-relaxed animate-fade-in max-w-2xl">
            This isn’t a tracker. It’s a new economy. And, we know how to help.
          </p>

          {/* Button */}
          <div className="mt-8 sm:mt-12">
            <button
              onClick={() => {
                document
                  .getElementById("tariff-contact-form")
                  ?.scrollIntoView({ behavior: "smooth" });
              }}
              className="inline-block bg-main-green text-main-dark px-6 py-3 sm:px-8 sm:py-4 rounded-lg text-base sm:text-lg font-bold shadow-lg hover:bg-accent-blue hover:text-main-light transition-all duration-300"
            >
              Send Your Query
            </button>
          </div>
        </div>
      </section>

      <section
        className="bg-main-light py-16 px-6 sm:px-12 lg:px-16"
        id="what-we-are-building"
      >
        {/* Heading */}
        <div className="text-center">
          <h2 className="text-4xl sm:text-5xl font-barlow font-extrabold text-main-dark mb-6 animate-slide-in">
            What We’re Building
          </h2>
          <p className="text-xl font-aeonik text-text-color mb-12 animate-fade-in">
            A New Financial Ecosystem Designed Around Global Tariff Power
          </p>
          <p className="text-base sm:text-lg font-aeonik text-text-color max-w-4xl mx-auto mb-12 animate-fade-in">
            The Tariff Stock Exchange isn’t a platform. It’s a new financial
            order—built for those who understand that in today’s world, policy
            is profit and trade disruptions are opportunities.
          </p>
        </div>

        {/* Feature Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-screen-xl mx-auto">
          {/* Card 1 */}
          <div className="p-6 bg-main-green shadow-lg rounded-3xl hover:shadow-2xl transition animate-fade-in cursor-pointer transform hover:scale-105">
            <h3 className="text-2xl font-barlow font-bold text-main-dark mb-4">
              ✅ 1. Tariff-Based Assets
            </h3>
            <p className="text-text-color font-aeonik leading-relaxed">
              New instruments and digital vehicles engineered to reflect tariff
              pressure points across countries, sectors, and supply chains. We
              create value from both winners and losers of trade wars.
            </p>
          </div>

          {/* Card 2 */}
          <div className="p-6 bg-main-green shadow-lg rounded-3xl hover:shadow-2xl transition animate-fade-in cursor-pointer transform hover:scale-105">
            <h3 className="text-2xl font-barlow font-bold text-main-dark mb-4">
              ✅ 2. Tariff Chip© & Tariff Processor©
            </h3>
            <p className="text-text-color font-aeonik leading-relaxed">
              Proprietary AI-powered trade intelligence hardware that processes,
              encrypts, and accelerates real-time tariff data for high-level
              decision-making.
            </p>
          </div>

          {/* Card 3 */}
          <div className="p-6 bg-main-green shadow-lg rounded-3xl hover:shadow-2xl transition animate-fade-in-delay cursor-pointer transform hover:scale-105">
            <h3 className="text-2xl font-barlow font-bold text-main-dark mb-4">
              ✅ 3. Tariff Coin©
            </h3>
            <p className="text-text-color font-aeonik leading-relaxed">
              A native digital token used for access, staking, forecasting, and
              profit-sharing from tariff-based opportunities. A monetization
              mechanism for trade conflict.
            </p>
          </div>

          {/* Card 4 */}
          <div className="p-6 bg-main-green shadow-lg rounded-3xl hover:shadow-2xl transition animate-fade-in cursor-pointer transform hover:scale-105">
            <h3 className="text-2xl font-barlow font-bold text-main-dark mb-4">
              ✅ 4. Policy Prediction Markets
            </h3>
            <p className="text-text-color font-aeonik leading-relaxed">
              Predict tariff decisions, supply chain shifts, or trade deals—get
              rewarded for accurate geopolitical foresight. Turn intelligence
              into returns.
            </p>
          </div>

          {/* Card 5 */}
          <div className="p-6 bg-main-green shadow-lg rounded-3xl hover:shadow-2xl transition animate-fade-in cursor-pointer transform hover:scale-105">
            <h3 className="text-2xl font-barlow font-bold text-main-dark mb-4">
              ✅ 5. Country and Sector Dashboards
            </h3>
            <p className="text-text-color font-aeonik leading-relaxed">
              Dynamic dashboards showing tariff impact, risk exposure, and
              opportunity flows across 250+ countries and key industries. A
              command center for modern trade.
            </p>
          </div>

          {/* Card 6 */}
          <div className="p-6 bg-main-green shadow-lg rounded-3xl hover:shadow-2xl transition animate-fade-in-delay cursor-pointer transform hover:scale-105">
            <h3 className="text-2xl font-barlow font-bold text-main-dark mb-4">
              ✅ 6. A Global Network of Builders
            </h3>
            <p className="text-text-color font-aeonik leading-relaxed">
              A syndicate of exporters, investors, and strategists who don’t
              wait for policy—they engineer systems around it. We see tariff
              disruption as an investment class.
            </p>
          </div>
        </div>

        <div className="text-center mt-16 max-w-4xl mx-auto animate-fade-in">
          <p className="text-xl font-aeonik text-text-color">
            This is more than Fintech. This is trade intelligence weaponized.
            Welcome to the ecosystem that profits where others panic.
          </p>
        </div>
      </section>

      <div className="w-full px-4 py-12 bg-gradient-to-br from-white via-gray-50 to-white">
        <div className="max-w-7xl mx-auto text-center">
          {/* Country Dropdown */}

          {/* Hero Heading */}
          <h1 className="text-4xl md:text-5xl font-bold mb-4 leading-tight">
            Welcome to the World’s First <br />
            <span className=" mt-5">Tariff Real Estate Portal</span>
          </h1>

          {/* Tagline */}
          <p className="text-lg md:text-xl text-gray-700 mb-6">
            This is where <strong>Real Estate Anchors Profit</strong>—and
            <strong>Tariffs Trigger Opportunity</strong>.
          </p>

          {/* Subheading */}
          <p className="text-base md:text-lg text-gray-600 mb-10 max-w-3xl mx-auto">
            Welcome to the world's first
            <strong>Tariff Real Estate Portal</strong>, where every square foot
            of property isn't just an asset—it's a
            <strong> strategic node in the new global economy</strong>.
          </p>

          {/* Cards Section */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-main-green p-6 rounded-2xl shadow-2xl hover:scale-105 transition-transform">
              <h3 className="text-xl font-semibold mb-2 text-dark">
                Company + Property = Power
              </h3>
              <p className="text-gray-700">
                Every chamber or company sold is bundled with a high-value real
                estate asset in Karachi.
              </p>
            </div>

            <div className="bg-main-green p-6 rounded-2xl shadow-2xl hover:scale-105 transition-transform">
              <h3 className="text-xl font-semibold mb-2 text-dark">
                Launchpads for Global Trade
              </h3>
              <p className="text-gray-700">
                Each property becomes a live trade zone, ready to trigger
                investment, policy, and international partnerships.
              </p>
            </div>

            <div className="bg-main-green p-6 rounded-2xl shadow-2xl hover:scale-105 transition-transform">
              <h3 className="text-xl font-semibold mb-2 text-dark">
                Real Estate as Infrastructure
              </h3>
              <p className="text-gray-700">
                Your office is more than space—it's collateral, infrastructure,
                and insurance for a new economic order.
              </p>
            </div>
          </div>
          <div className="mb-8 flex justify-center mt-8">
            <div className="w-full max-w-xs">
              <CountryDropdown />
            </div>
          </div>
        </div>
      </div>

      <section
        className="bg-main-light mt-12 px-6 sm:px-12 lg:px-16"
        id="who-its-for"
      >
        <div className="max-w-screen-xl mx-auto text-center">
          <h2 className="text-4xl pt-12 sm:text-5xl font-barlow font-extrabold text-main-dark mb-12 animate-slide-in">
            Who It’s For
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                title: "Investors",
                description:
                  "Looking for new asset classes beyond crypto, equities, and bonds. Because volatility has a pattern—and tariff economics is the next wave.",
              },
              {
                title: "Exporters & Manufacturers",
                description:
                  "Navigating shifting policies, disrupted supply chains, and rising duties. We help you respond before the tariffs hit your margin.",
              },
              {
                title: "Governments & Trade Agencies",
                description:
                  "Seeking real-time policy simulations, economic foresight, and sovereign trade advantage. Deploy dashboards, chips, and microprocessors built for global leverage.",
              },
              {
                title: "Fintech Builders & Blockchain Developers",
                description:
                  "Ready to co-create tokenized systems, predictive tools, and smart contracts for the new economy. Join the infrastructure layer of post-globalization finance.",
              },
              {
                title: "Geopolitical Analysts & Trade Strategists",
                description:
                  "Who understand that behind every headline is a profitable signal. Now you can monetize your foresight.",
              },
            ].map((card, idx) => (
              <div
                key={idx}
                className="relative bg-main-green p-8 rounded-2xl shadow-lg hover:shadow-2xl hover:bg-white transition-all duration-300 animate-fade-in"
              >
                <h3 className="text-xl text-left font-barlow font-bold text-main-dark mb-4">
                  {card.title}
                </h3>
                <p className="text-sm text-left font-aeonik text-gray-600">
                  {card.description}
                </p>
                <div className="absolute inset-0 bg-main-green opacity-0 hover:opacity-10 rounded-2xl transition-opacity duration-300"></div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section
        className="bg-main-light py-16 px-6 sm:px-12 lg:px-20"
        id="why-now"
      >
        <div className="max-w-6xl mx-auto">
          <div className="text-center">
            <h2 className="text-4xl sm:text-5xl font-barlow font-extrabold text-main-dark mb-2 mt-4 animate-slide-in">
              Why Now
            </h2>
            <p className="text-lg sm:text-xl font-aeonik text-text-color leading-relaxed mb-8 animate-fade-in">
              The global economic map is being redrawn—one tariff at a time.
            </p>
          </div>

          <div className="relative flex flex-col lg:flex-row items-center bg-white shadow-lg hover:shadow-2xl rounded-3xl overflow-hidden transition-all duration-300 animate-slide-in">
            <div className="w-full p-8 sm:p-12">
              <p className="text-base sm:text-lg font-aeonik text-text-color mb-6 leading-relaxed paragraph_mobile">
                Trade is no longer governed by free market principles. <br />
                It’s now dictated by tariff strikes, retaliatory taxes, and
                economic nationalism. <br />
                What used to be background noise in global finance is now the
                loudest signal in the room.
              </p>

              <div className="space-y-4 text-base sm:text-lg font-aeonik text-text-color leading-relaxed">
                <p>
                  🔺 <strong>U.S.–China Trade Escalation</strong>
                  <br />
                  Massive tariff hikes on both sides are redefining supply
                  chains, investment flows, and global manufacturing.
                </p>

                <p>
                  🔺 <strong>Carbon Tariffs & Green Trade Blocks</strong>
                  <br />
                  The EU and others are weaponizing climate regulations as trade
                  policy, creating invisible walls in global commerce.
                </p>

                <p>
                  🔺 <strong>Developing Economies in the Crossfire</strong>
                  <br />
                  Countries like Pakistan are being hit by superpower tariff
                  crossfire—with no tools to respond or leverage it.
                </p>

                <p>
                  🔺 <strong>The Breakdown of Global Institutions</strong>
                  <br />
                  WTO influence is declining. Nations are going bilateral,
                  regional, or solo—with no global coordination.
                </p>

                <p>
                  🔺 <strong>Policy Is the New Currency</strong>
                  <br />
                  In a volatile, fractured world, policy—not productivity—is the
                  main driver of value. Those who can predict it, trade it, or
                  build around it will win.
                </p>
              </div>

              <p className="mt-6 text-base sm:text-lg font-aeonik text-text-color leading-relaxed">
                We’re not waiting for the old world to recover. <br />
                <strong>We’re building the new one—right now.</strong>
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-main-light px-6 sm:px-12 lg:px-20" id="our-vision">
        <div className="max-w-6xl mx-auto">
          <div className="text-center">
            <h2 className="text-4xl sm:text-5xl font-barlow font-extrabold text-main-dark mb-2 mt-4 animate-slide-in">
              Our Vision
            </h2>
            <p className="text-lg sm:text-xl font-aeonik text-text-color leading-relaxed mb-8 animate-fade-in">
              To build the first financial ecosystem that thrives on global
              disruption.
            </p>
          </div>

          <div className="relative bg-white shadow-lg hover:shadow-2xl rounded-3xl overflow-hidden transition-all duration-300 animate-slide-in">
            <div className="p-8 sm:p-12 space-y-6 text-base sm:text-lg font-aeonik text-text-color leading-relaxed">
              <p>
                The old financial world was built on assumptions:
                <br />
                — Open markets
                <br />
                — Predictable policy
                <br />
                — Peaceful globalization
                <br />
                That world is gone.
              </p>
              <p>
                Our vision is to construct a new system—one where volatility
                becomes strategy, policy becomes profit, and tariffs become
                tools of wealth.
              </p>
              <p>
                We’re not creating another exchange.
                <br />
                We’re creating an economic weapon system for those smart enough
                to wield it.
              </p>
              <p>
                We envision a global economy where countries, companies, and
                individuals don’t suffer from tariffs—they lead with them.
              </p>
            </div>
          </div>

          <section className="bg-main-light py-16 px-6 sm:px-12 lg:px-20">
            <div className="max-w-6xl mx-auto">
              <div className="text-center mb-12">
                <h2 className="text-4xl sm:text-5xl font-barlow font-extrabold text-main-dark mb-4 animate-slide-in">
                  Tariff Coin (TFC)
                </h2>
                <p className="text-lg sm:text-xl font-aeonik text-text-color animate-fade-in">
                  The Utility Token of the Tariff Economy
                </p>
                <p className="text-base sm:text-lg font-aeonik text-text-color mt-4 max-w-2xl mx-auto">
                  Tariff Coin is the engine of this ecosystem. It's not just
                  currency—it’s functionality.
                  <br />
                  TFC powers access, intelligence, and influence across the
                  Tariff Stock Exchange platform.
                </p>
              </div>

              <div className="bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden flex flex-col lg:flex-row">
                <div className="lg:w-1/2 w-full h-64 lg:h-auto">
                  <img
                    src={YoungImg}
                    alt="Tariff Coin Team"
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="lg:w-1/2 w-full p-8 sm:p-12 flex flex-col justify-center">
                  <h3 className="text-xl font-bold text-main-dark mb-4 flex items-center gap-2">
                    <span role="img" aria-label="tool">
                      🛠️
                    </span>
                    What Tariff Coin does:
                  </h3>
                  <ul className="list-disc pl-5 space-y-4 text-base sm:text-lg font-aeonik text-text-color">
                    <li>
                      <strong>Unlock premium intelligence:</strong>
                      <br />
                      Pay with TFC to access advanced trade forecasts, policy
                      simulations, and dashboards.
                    </li>
                    <li>
                      <strong>Stake predictions:</strong>
                      <br />
                      Back your geopolitical foresight with TFC and earn from
                      accuracy.
                    </li>
                    <li>
                      <strong>Power the protocol:</strong>
                      <br />
                      Used across every system layer—from microprocessor
                      licensing to data API calls.
                    </li>
                    <li>
                      <strong>Govern the future:</strong>
                      <br />
                      TFC holders help shape product features, ecosystem
                      decisions, and country focus.
                    </li>
                  </ul>
                  <p className="mt-6 text-base sm:text-lg font-aeonik text-text-color">
                    Tariff Coin transforms speculation into strategy— turning
                    every global disruption into a tokenized opportunity.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <div className="text-center mt-8" id="tariff-contact-form">
            <h2 className="text-4xl sm:text-5xl font-barlow font-extrabold text-main-dark mb-4 animate-slide-in">
              Call to Action
            </h2>
            <p className="text-lg sm:text-xl font-aeonik text-text-color leading-relaxed mb-8 animate-fade-in">
              This is the beginning of the new financial war room.
            </p>
          </div>

          <div className="relative bg-white shadow-lg hover:shadow-2xl rounded-3xl overflow-hidden transition-all duration-300 animate-slide-in">
            <div className="p-8 sm:p-12 space-y-6 text-base sm:text-lg font-aeonik text-text-color leading-relaxed">
              <p>
                The trade world is shifting fast.
                <br />
                Power is being redefined.
                <br />
                And tariffs are no longer policy—they are capital.
              </p>
              <p>
                If you're ready to think bigger than crypto,
                <br />
                If you're ready to build wealth from volatility,
                <br />
                If you're ready to profit from the pulse of global disruption—
              </p>
              <p className="text-main-dark font-bold">
                Welcome to the Tariff Stock Exchange.
              </p>

              <div className="space-y-4 mt-8">
                <div className="mt-8">
                  <Link
                    to="/"
                    className="inline-block bg-main-dark text-white px-8 py-4 rounded-lg text-lg font-bold shadow-lg hover:bg-gray-800 transition-all duration-300"
                  >
                    Join the Ecosystem
                  </Link>
                </div>
                <p>
                  Be part of the founding network of investors, builders,
                  economists, and strategic thinkers.
                  <br />
                  Send us your Intent
                </p>

                <div className="bg-white rounded-xl shadow-md p-6 sm:p-8 max-w-lg mx-auto mt-10">
                  <p className="text-xl font-bold text-main-dark mb-1">
                    ✅ Follow the Movement
                  </p>
                  <p className="text-gray-600 mb-6">
                    Stay updated with trade signals, platform drops, and launch
                    timelines.
                  </p>

                  <form onSubmit={handleSubmit} className="space-y-4">
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Your Name"
                      className="w-full px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-main-green transition-all duration-200"
                    />

                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Your Email"
                      className="w-full px-4 py-3 rounded-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-main-green transition-all duration-200"
                    />

                    <button
                      type="submit"
                      className="w-full bg-lime-400 hover:bg-lime-500 text-black font-semibold py-3 px-6 rounded-md shadow-md transition duration-300"
                    >
                      Submit
                    </button>
                  </form>
                </div>

                <p>
                  Dive deep into the architecture, tokenomics, and future of the
                  Tariff Economy.
                  <br />
                  PDF to be inserted here
                </p>
                <button
                  onClick={handleDownload}
                  className="bg-main-green text-main-dark px-8 py-4 rounded-lg text-lg font-bold shadow-lg hover:bg-accent-blue hover:text-main-light transition-all duration-300"
                >
                  Download the Whitepaper
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="bg-main-light py-16 px-6 sm:px-12 lg:px-20"
        id="about-the-founder"
      >
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl sm:text-5xl font-barlow font-extrabold text-main-dark mb-2 animate-slide-in">
              About the Founder
            </h2>
            <p className="text-lg sm:text-xl font-aeonik text-text-color animate-fade-in">
              Meet the mind behind the Tariff Stock Exchange
            </p>
          </div>

          <div className="bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden">
            <div className="grid grid-cols-1 lg:grid-cols-12">
              <div className="lg:col-span-4 w-full h-full">
                <img
                  src={FounderImg}
                  alt="Dr. Czar"
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="lg:col-span-8 w-full p-8 sm:p-12 flex flex-col justify-center text-base sm:text-lg font-aeonik text-text-color leading-relaxed space-y-5">
                <p>
                  <strong>Dr. Czar</strong> is a visionary economist, fintech
                  strategist, and creator of over 100 global business ventures—
                  including universities, public companies, and revolutionary
                  trade models.
                </p>
                <p>
                  With deep roots in economic biochemistry, AI economics, and
                  real-world geopolitical systems, Dr. Czar has built an
                  ecosystem that doesn’t wait for permission—it creates new
                  paradigms.
                </p>
                <p>
                  From launching the <strong>Institute of Billionaires</strong>
                  to pioneering the <strong>Billionaire Stock Exchange</strong>,
                  Dr. Czar’s mission is consistent:
                </p>
                <blockquote className="border-l-4 border-main-green pl-4 italic text-main-dark font-semibold">
                  “Design the financial infrastructure of the future—
                  <br />
                  before others even see it coming.”
                </blockquote>
                <p>
                  The <strong>Tariff Stock Exchange</strong> is his answer to a
                  world in chaos— a system that transforms disorder into
                  opportunity, and tariffs into wealth.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="bg-gradient-to-r from-main-light via-white to-main-light py-12 px-6 text-text-color font-barlow mt-8">
        <div class="max-w-5xl mx-auto shadow-2xl rounded-xl overflow-hidden bg-white relative">
          <div class="absolute inset-0 bg-gradient-to-b from-transparent to-main-light opacity-30 pointer-events-none"></div>
          <div class="p-10">
            <h2 class="text-4xl font-extrabold text-main-dark animate-fade-in text-center mb-4">
              <span class="underline decoration-main-green decoration-4">
                Live Chat & 24/7 Support
              </span>
            </h2>
            <p class="text-lg text-center text-gray-700 animate-slide-in paragraph_mobile">
              Our Live Chat 24/7 Support is here to assist you at every step of
              your journey. Whether you have questions about our program price
              plans, need guidance through the admissions process, or want to
              learn more about how IPC can help you achieve your career goals,
              our team is always ready to help.
            </p>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6 p-4 lg:p-10 animate-fade-in-delay">
            <div class="flex items-center gap-4">
              <div class="bg-main-green text-main-dark w-12 h-12 flex justify-center items-center rounded-full shadow-md animate-bounce">
                <i class="fas fa-clock text-xl"></i>
              </div>
              <p class="text-lg font-medium paragraph_mobile">
                24/7 Availability: Our team is here to assist you any time, day
                or night.
              </p>
            </div>

            <div class="flex items-center gap-4">
              <div class="bg-main-green text-main-dark w-12 h-12 flex justify-center items-center rounded-full shadow-md animate-bounce">
                <i class="fas fa-user text-xl"></i>
              </div>
              <p class="text-lg font-medium paragraph_mobile">
                Dedicated Experts: Personalized support tailored to meet your
                needs.
              </p>
            </div>

            <div class="flex items-center gap-4">
              <div class="bg-main-green text-main-dark w-12 h-12 flex justify-center items-center rounded-full shadow-md animate-bounce">
                <i class="fas fa-comments text-xl"></i>
              </div>
              <p class="text-lg font-medium paragraph_mobile">
                Clear Communication: Get detailed guidance on admissions, plans,
                and more.
              </p>
            </div>

            <div class="flex items-center gap-4">
              <div class="bg-main-green text-main-dark w-12 h-12 flex justify-center items-center rounded-full shadow-md animate-bounce">
                <i class="fas fa-handshake text-xl"></i>
              </div>
              <p class="text-lg font-medium paragraph_mobile">
                Trusted Support: Depend on us for seamless assistance and peace
                of mind.
              </p>
            </div>
          </div>

          <div class="flex justify-center mt-6 pb-10">
            <button class="bg-gradient-to-r from-main-green to-green-500 text-white px-8 py-4 rounded-full font-extrabold shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-300 text-lg">
              Start a Conversation
            </button>
          </div>
        </div>
      </section>

      <TestimonialSlider />

      <div
        id="whitepaper"
        ref={paperRef}
        style={{
          display: "none",
          fontFamily: "Segoe UI, sans-serif",
          color: "#333",
          maxWidth: "900px",
          margin: "auto",
          padding: "40px",
          backgroundColor: "#f9f9ff",
          borderRadius: "12px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
        }}
      >
        <h1
          style={{
            textAlign: "center",
            fontSize: "32px",
            fontWeight: "800",
            color: "#1d3557",
            marginBottom: "10px",
          }}
        >
          Whitepaper: Tariff Stock Exchange (TSE)
        </h1>
        <h2
          style={{
            textAlign: "center",
            fontSize: "18px",
            color: "#457b9d",
            marginBottom: "30px",
          }}
        >
          Transforming Tariffs into the Backbone of a New Financial Ecosystem
        </h2>

        {/* Section: Executive Summary */}
        <h3
          style={{
            color: "#1d3557",
            fontSize: "18px",
            fontWeight: "700",
            marginTop: "30px",
          }}
        >
          Executive Summary
        </h3>
        <p>
          The global economy is being redefined—not by innovation or natural
          evolution, but by the resurgence of tariffs, trade conflicts, and
          economic nationalism. In an era where every policy shift can cause a
          ripple across borders, <strong>Tariff Stock Exchange (TSE)</strong>
          introduces a bold vision: to convert disruption into infrastructure,
          policy into profit, and fear into foresight.
        </p>
        <p>
          TSE is not a tracking tool or a traditional marketplace—it is a new
          class of economic engine built around the strategic monetization of
          tariffs. With the integration of <strong>Tariff Coin</strong>,
          <strong>Tariff Chips</strong>, <strong>Prediction Markets</strong>,
          and a <strong>Global Economic Intelligence Network</strong>, the TSE
          ecosystem enables governments, investors, and industries to thrive
          amid chaos.
        </p>

        {/* Section: Problem Statement */}
        <h3
          style={{
            color: "#1d3557",
            fontSize: "18px",
            fontWeight: "700",
            marginTop: "30px",
          }}
        >
          1. Problem Statement
        </h3>
        <p>
          Tariffs are no longer just fiscal tools—they have become the modern
          weapons of economic warfare. They influence the price of goods,
          reroute supply chains, create inflationary pressures, and disrupt
          geopolitical stability. Despite their massive impact, there exists no
          dedicated system to navigate, capitalize on, or strategically resolve
          tariff-based disruptions.
        </p>
        <p>
          While environmental crises gain attention, trade conflicts often go
          unrecognized as an existential economic threat. However, for many
          developing nations, tariff warfare can trigger recessions, fuel
          unemployment, and destabilize currencies.
        </p>

        {/* Section: Vision */}
        <h3
          style={{
            color: "#1d3557",
            fontSize: "18px",
            fontWeight: "700",
            marginTop: "30px",
          }}
        >
          2. The Vision
        </h3>
        <p>
          Tariff Stock Exchange emerges with a revolutionary objective: to
          establish a fully integrated financial ecosystem built around
          tariff-driven dynamics. Rather than reacting to trade wars, we
          architect instruments that can convert every policy into an
          opportunity.
        </p>
        <p>
          We believe that by creating this infrastructure, nations and
          individuals can not only protect themselves from tariff fallout—but
          use the system to grow, profit, and stabilize their economies.
        </p>

        {/* Section: Ecosystem */}
        <h3
          style={{
            color: "#1d3557",
            fontSize: "18px",
            fontWeight: "700",
            marginTop: "30px",
          }}
        >
          3. Components of the Ecosystem
        </h3>
        <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
          <li>
            <strong>Tariff Coin (TFC):</strong> A utility token designed to
            unlock access to data, trade predictions, analytics, and influence
            over the ecosystem’s governance.
          </li>
          <li>
            <strong>Tariff-Based Assets:</strong> Sectoral, bilateral, and
            regional instruments that reflect tariff pressure and economic
            opportunity in real-time.
          </li>
          <li>
            <strong>Tariff Chip & Tariff Microprocessor:</strong> Hardware
            systems for sovereign and institutional deployment, capable of
            analyzing, encrypting, and simulating tariff impacts at scale.
          </li>
          <li>
            <strong>Policy Prediction Markets:</strong> Crowdsourced forecasting
            systems allowing experts, analysts, and citizens to predict trade
            outcomes, policy changes, and disruptions—with financial rewards for
            accuracy.
          </li>
          <li>
            <strong>Global Intelligence Dashboards:</strong> A data interface
            for countries, companies, and trade blocs—offering insight into
            risk, opportunity, and policy response.
          </li>
        </ul>

        {/* Section: Benefits */}
        <h3
          style={{
            color: "#1d3557",
            fontSize: "18px",
            fontWeight: "700",
            marginTop: "30px",
          }}
        >
          4. Strategic Benefits
        </h3>
        <ul style={{ paddingLeft: "20px", lineHeight: "1.7" }}>
          <li>
            <strong>Economic Sovereignty:</strong> Countries gain tools to make
            data decisions, rather than reacting to foreign tariffs blindly.
          </li>
          <li>
            <strong>Investor Advantage:</strong> New classes of trade-based,
            tariff-indexed assets allow investors to gain exposure to
            geopolitical volatility.
          </li>
          <li>
            <strong>Manufacturing Insight:</strong> Companies can forecast cost
            swings and proactively shift sourcing, production, and distribution.
          </li>
          <li>
            <strong>Diplomatic Leverage:</strong> Governments can simulate
            policy decisions and deploy countermeasures strategically, not
            emotionally.
          </li>
        </ul>

        {/* Section: Bigger Picture */}
        <h3
          style={{
            color: "#1d3557",
            fontSize: "18px",
            fontWeight: "700",
            marginTop: "30px",
          }}
        >
          5. The Bigger Picture
        </h3>
        <p>
          Our belief is simple:
          <strong style={{ color: "#1d3557" }}>
            if we can quantify disruption, we can profit from it—and ultimately,
            we can resolve it.
          </strong>
        </p>
        <p>
          TSE doesn't glorify economic conflict. It exists to give all
          stakeholders—especially those from vulnerable economies—the power to
          act with clarity, to trade with knowledge, and to govern with
          foresight. When properly understood, tariffs can become a
          <strong>mechanism of global balance</strong>, not just chaos.
        </p>
        <p>
          In many ways,
          <strong>
            tariff-based instability is a bigger long-term threat than
            environmental collapse
          </strong>
          , because it erodes the foundations of trade, cooperation, and mutual
          growth. But unlike climate change, this challenge can be resolved
          today—by building the right systems.
        </p>

        {/* Section: Conclusion */}
        <h3
          style={{
            color: "#1d3557",
            fontSize: "18px",
            fontWeight: "700",
            marginTop: "30px",
          }}
        >
          6. Conclusion
        </h3>
        <p>
          The Tariff Stock Exchange is not an alternative financial
          experiment—it is a new baseline. A foundation for those who choose to
          see the next crisis not with fear, but with tools.
        </p>
        <p>
          This is not just a platform. It is the
          <strong>infrastructure for the post-globalization world</strong>.
        </p>

        {/* Footer */}
        <div
          style={{
            marginTop: "40px",
            textAlign: "center",
            fontSize: "16px",
            color: "#555",
          }}
        >
          <p>
            <strong>Website:</strong>
            <a
              href="https://tariffstockexchange.com"
              style={{ color: "#1d3557" }}
            >
              TariffStockExchange.com
            </a>
          </p>
          <p>
            <strong>Status:</strong> Launching Q2 2025
          </p>
          <p>
            <strong>Contact:</strong>
            <a
              href="mailto:info@TariffStockExchange.com"
              style={{ color: "#1d3557" }}
            >
              info@TariffStockExchange.com
            </a>
          </p>
        </div>
      </div>
    </>
  );
};

export default Home;
